import { useInRouterContext, useNavigate } from 'react-router-dom';

type NavigateFunction = (route: string) => void;
type UseNavigate = () => NavigateFunction;

const useLocationChange = (): NavigateFunction => (
  (route: string) => { window.location.href = route; }
);

function useNavigateHook(): UseNavigate {
  const isInRouterContext = useInRouterContext();
  return isInRouterContext ? useNavigate : useLocationChange;
}

export default useNavigateHook;
